<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>Entry Points</h1>
      <ol class="breadcrumb">
        <li>
          <a href="#"><i class="fa fa-dashboard"></i> Home</a>
        </li>
        <li class="active">Entry Points</li>
      </ol>
    </section>

    <section class="content">
      <div ref="tabBox" class="nav-tabs-custom">
        <ul class="nav nav-tabs">
          <li :class="{ active: activeTab === 'create-new' }">
            <a href="#" @click.prevent="setTab('create-new')"
              >Create new entry point</a
            >
          </li>
          <li :class="{ active: activeTab === 'journey-defaults' }">
            <a href="#" @click.prevent="setTab('journey-defaults')"
              >Journey defaults</a
            >
          </li>
          <li :class="{ active: activeTab === 'all-entry-points' }">
            <a href="#" @click.prevent="setTab('all-entry-points')"
              >All entry points</a
            >
          </li>
        </ul>

        <div class="tab-content" style="padding: 0px">
          <create-new-entry-point v-show="activeTab === 'create-new'" />
          <journey-defaults v-if="activeTab === 'journey-defaults'" />
          <all-entry-points v-if="activeTab === 'all-entry-points'" @tab-change="setTab($event)" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint-disable */
import CreateNewEntryPoint from "@/components/entry-points/create-new-entry-point/CreateNewEntryPoint.vue";
import JourneyDefaults from "@/components/entry-points/journey-defaults/JourneyDefaults.vue";
import AllEntryPoints from "@/components/entry-points/all-entry-points/AllEntryPoints.vue";

export default {
  name: "EntryPoints",
  components: {
    CreateNewEntryPoint,
    JourneyDefaults,
    AllEntryPoints,
  },
  data() {
    return {
      activeTab: "create-new",
    };
  },
  watch: {
    "$route.query.tab"(tab) {
      this.activeTab = tab || "create-new";
    },
  },
  mounted() {
    this.activeTab = this.$route.query.tab || "create-new";
    this._setHeight()
    window.addEventListener('resize', this._setHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._setHeight)
    if (this.$refs.tabBox) this.$refs.tabBox.style.height = ''
  },
  methods: {
    setTab(tab) {
      if (this.$route.query.tab === tab) return;
      this.$router.push({ query: { ...this.$route.query, tab } });
    },
    _setHeight() {
      const el = this.$refs.tabBox
      if (!el) return
      const top = el.getBoundingClientRect().top
      el.style.height = (window.innerHeight - top - 10) + 'px'
    }
  }
};
/* eslint-enable */
</script>
<style src="./EntryPoints.css"></style>



// WEBPACK FOOTER //
// EntryPoints.vue?1e2c0976